import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import {
  installConsoleFilter,
  setLogLevel,
} from './app/services/shared/log';

// 1. Configura il livello di log dal file environment (dev: 'debug',
//    prod: 'warn'). Il livello e' configurabile a runtime via
//    setLogLevel() se servisse (es. flag in URL '?log=info').
setLogLevel(environment.LOG_LEVEL);

// 2. Installa il filter globale su window.console: tutti i console.*
//    esistenti nel codice rispettano il livello configurato. Sostituisce
//    il vecchio override che azzerava console.log/debug solo in prod e
//    lasciava console.warn/error attivi (esponendo dati sensibili).
installConsoleFilter();

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
